import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { createRowMap, createTableColumns, urlParamsMapper } from 'src/helpers';
import { EMPLOYEE_TEAM_DETAIL_URL, EMPLOYEE_DETAIL_URL } from 'src/constants/constants.js';
import { fetchEmployeesApi } from 'src/services/employees.service';
import { TableLanding } from 'src/ui/library/Table/extensions';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';
import { Grid } from '@material-ui/core';

class EmployeesTableContainer extends Component {
  getTableColumns = () => {
    const allColumns = ['employeeId', 'fullName', 'email', 'businessPhone', 'mobilePhone', 'country'];
    const visibleColumns = ['fullName', 'email'];

    /* Create columns config object used in <Table /> */
    const columns = createTableColumns('employees.landing', {
      columns: allColumns,
      visible: visibleColumns,
      options: {},
    });

    return columns;
  };

  onTableChange = (actionType, data, ...otherData) => {
    const { team } = this.props;
    switch (actionType) {
      case 'viewDetail':
      case 'rowClick':
        const {
          model: { columns, rows },
          rowClicked: { origRowIndex },
        } = data;

        const { employeeId } = createRowMap(columns, rows[origRowIndex]);
        const employeeDetailUrl = urlParamsMapper(team === true ? EMPLOYEE_TEAM_DETAIL_URL : EMPLOYEE_DETAIL_URL, {
          employeeId: employeeId,
        });
        this.props.history.push(employeeDetailUrl);
        break;
      default:
        return undefined;
    }
  };

  render() {
    return (
      <div className={fnShowNewDashboard() ? 'employeed-landing-container' : null}>
        <Grid item md={12}>
          <div className="employeesHeader">
            <div className="font-18 font-bold">{intl.get('employees.landing.pageTitle')}</div>
          </div>
        </Grid>
        <TableLanding
          history={this.props.history}
          columns={this.getTableColumns()}
          actionable={true}
          sortDirection={'asc'}
          sortColumn={'fullName'}
          gridFilter={{
            hideFilterButton: true,
          }}
          onRequestData={fetchEmployeesApi}
          onTableChange={this.onTableChange}
          caption={intl.get('employees.landing.caption')}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesTableContainer);
